import apiLight from './api-light'

const ContactService = {
  async sendContactMail(
    firstName: string,
    lastName: string,
    email: string,
    subject: string,
    message: string,
  ): Promise<string> {
    const { data } = await apiLight.post('/v1/contact', {
      email: email,
      firstname: firstName,
      lastname: lastName,
      subject: subject,
      text: message,
    })
    return data
  },
}

export default ContactService
